export type Language = 'tr' | 'en';

export const translations: Record<Language, Record<string, string>> = {
  tr: {
    // Instructions
    instruction1: '1. Hesap numarasını kopyalayın ve bankacılık uygulamanızı açın',
    instruction2: '2. Tek seferde tam olarak {amount} TRY gönderin',
    instruction3: '3. Buraya geri dönün ve transferi onaylayın',

    // Transfer details
    copyTransferDetails: 'Transfer bilgilerini kopyala',
    bankName: 'Banka',
    cardNumber: 'Alıcı kartı',
    phoneNumber: 'Telefon numarası',
    accountHolder: 'Hesap sahibi',

    // Status
    waitingForTransfer: 'Transferinizi bekliyoruz:',
    minutesShort: 'd',
    secondsShort: 's',

    // Button
    sentMoney: 'Parayı gönderdim',
    processing: 'İşleniyor...',
    timeExpired: 'Süre doldu',
    paymentConfirmed: 'Ödeme onaylandı',
    cancelPayment: 'İptal et (ödeme yapmadım)',

    // Hint
    sendExactAmount: 'İşlemlerde gecikmeleri önlemek için tek seferde tam tutarı gönderin',

    // Copy
    copy: 'Kopyala',
    successfullyCopied: 'Başarıyla kopyalandı!',

    // States
    loading: 'Ödeme bilgileri yükleniyor...',
    preparingPayment: 'Ödeme bilgileri hazırlanıyor',
    pleaseWait: 'Lütfen bekleyin.',
    paymentNotFound: 'Ödeme kimliği bulunamadı',
    dataNotFound: 'Ödeme bilgileri bulunamadı',

    // Confirm dialogs
    success: 'Ödeme onaylandı',
    successDescription: 'Transferiniz başarıyla alındı ve doğrulandı.',
    successReturnHint: 'Şimdi siteye geri dönebilirsiniz.',
    expired: 'Ödeme oturumu sona erdi',
    expiredDescription: 'Ödeme süresi doldu ve bu transfer talebi artık aktif değil.',
    expiredHint: 'Devam etmek için lütfen yeni bir ödeme talebi oluşturun.',
    expiredTryAgain: 'Tekrar dene',

    // Failed page
    failedTitle: 'Ödeme onaylanmadı',
    failedDescription: 'Transferinizi beklenen süre içinde doğrulayamadık.',
    failedHint: 'Para gönderildiyse, daha sonra işlenebilir veya sağlayıcınız tarafından iade edilebilir.',
    tryAgain: 'Tekrar dene',
    contactSupport: 'Destek ile iletişime geç',
    processingPayment: 'Ödeme işleniyor!',
    processingDescription: 'İşleminiz birkaç dakika içinde işlenmezse Müşteri Desteği ile iletişime geçin.',
    backToSite: 'Siteye geri dön',

    // Pending page
    pendingTitle: 'Ödeme doğrulanıyor',
    pendingDescription: 'Onayınızı aldık ve ödeme sağlayıcısının transferi doğrulamasını bekliyoruz. Bu genellikle birkaç dakika sürer.',
    pendingKeepOpen: 'Lütfen bu sayfayı açık tutun.',
    refreshStatus: 'Durumu yenile',
    backToMerchant: 'Siteye geri dön',

    // Receipt upload
    receiptUploadHint: 'İşlemi hızlandırmak için ödeme makbuzunu yükleyin',
    uploadReceipt: 'Makbuz yükle',
    receiptFormats: 'JPG, PNG, WebP veya PDF, maksimum 5 MB',
    receiptUploading: 'Yükleniyor...',
    receiptUploaded: 'Makbuz yüklendi',
    receiptUploadError: 'Yükleme başarısız',
    receiptFileTooLarge: 'Dosya çok büyük (maksimum 5 MB)',
    receiptInvalidFormat: 'Geçersiz dosya formatı',
    receiptRateLimited: 'Tekrar yüklemeden önce lütfen bekleyin',

    // Unavailable page
    unavailableTitle: 'Ödeme kullanılamıyor',
    unavailableDescription: 'Şu anda ödeme bilgileri oluşturulamadı.',
  },
  en: {
    // Instructions
    instruction1: '1. Copy the account number and open your banking app',
    instruction2: '2. Send exactly {amount} TRY in one payment',
    instruction3: '3. Return here and confirm the transfer',

    // Transfer details
    copyTransferDetails: 'Copy transfer details',
    bankName: 'Bank',
    cardNumber: 'Recipient card',
    phoneNumber: 'Phone number',
    accountHolder: 'Account holder',

    // Status
    waitingForTransfer: "We're waiting for your transfer:",
    minutesShort: 'm',
    secondsShort: 's',

    // Button
    sentMoney: "I've sent the money",
    processing: 'Processing...',
    timeExpired: 'Time expired',
    paymentConfirmed: 'Payment confirmed',
    cancelPayment: 'Cancel (I did not make the payment)',

    // Hint
    sendExactAmount: 'Send the exact amount in one payment to avoid delays in processing',

    // Copy
    copy: 'Copy',
    successfullyCopied: 'Successfully copied!',

    // States
    loading: 'Loading payment data...',
    preparingPayment: 'Preparing payment details',
    pleaseWait: 'Please wait a moment.',
    paymentNotFound: 'Payment ID not found',
    dataNotFound: 'Payment data not found',

    // Confirm dialogs
    success: 'Payment confirmed',
    successDescription: 'Your transfer has been successfully received and verified.',
    successReturnHint: 'You can now return to the site.',
    expired: 'Payment session expired',
    expiredDescription: 'The payment time has ended and this transfer request is no longer active.',
    expiredHint: 'Please create a new payment request to continue.',
    expiredTryAgain: 'Try again',

    // Failed page
    failedTitle: 'Payment not confirmed',
    failedDescription: "We couldn't verify your transfer within the expected time.",
    failedHint: 'If money was sent, it may still be processed later or returned by your provider.',
    tryAgain: 'Try again',
    contactSupport: 'Contact support',
    processingPayment: 'Processing payment!',
    processingDescription: 'Contact Customer Support if your transaction is not processed within a few minutes.',
    backToSite: 'Back to site',

    // Pending page
    pendingTitle: 'Payment is being verified',
    pendingDescription: "We received your confirmation and are waiting for the payment provider to verify the transfer. This usually takes a few minutes.",
    pendingKeepOpen: 'Please keep this page open.',
    refreshStatus: 'Refresh status',
    backToMerchant: 'Back to site',

    // Receipt upload
    receiptUploadHint: 'To speed up processing - upload a payment receipt',
    uploadReceipt: 'Upload receipt',
    receiptFormats: 'JPG, PNG, WebP or PDF, maximum 5 MB',
    receiptUploading: 'Uploading...',
    receiptUploaded: 'Receipt uploaded',
    receiptUploadError: 'Upload failed',
    receiptFileTooLarge: 'File too large (maximum 5 MB)',
    receiptInvalidFormat: 'Invalid file format',
    receiptRateLimited: 'Please wait before uploading again',

    // Unavailable page
    unavailableTitle: 'Payment unavailable',
    unavailableDescription: "We couldn't create payment details right now.",
  },
};

export type TranslationKey = keyof typeof translations.tr;

export const getLanguageFromUrl = (): Language => {
  const urlParams = new URLSearchParams(window.location.search);
  const lang = urlParams.get('lang');

  if (lang === 'en') return 'en';
  return 'tr';
};

export const t = (key: string, params?: Record<string, string | number>): string => {
  const lang = getLanguageFromUrl();
  let text = translations[lang][key] || translations.tr[key] || key;

  if (params) {
    Object.entries(params).forEach(([paramKey, value]) => {
      text = text.replace(`{${paramKey}}`, String(value));
    });
  }

  return text;
};

export const useTranslation = () => {
  const lang = getLanguageFromUrl();

  const translate = (key: string, params?: Record<string, string | number>): string => {
    let text = translations[lang][key] || translations.tr[key] || key;

    if (params) {
      Object.entries(params).forEach(([paramKey, value]) => {
        text = text.replace(`{${paramKey}}`, String(value));
      });
    }

    return text;
  };

  return { t: translate, lang };
};
